export const initialDataState = {};
export const WEEK_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const CASH_CENTER_TYPES = [
  {
    value: "bcc",
    label: "Single Bank - BCC",
  },
  {
    value: "mbcc",
    label: "Multi Bank - MBCC",
  },
];
export const CASH_CENTER_STATUS = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Closed",
    value: "Closed",
  },
];
export const LOADING_BAY_AREAS = [
  {
    value: "Offsite",
    label: "OffSite",
  },
  {
    value: "Onsite",
    label: "OnSite",
  },
];
export const CASH_CENTER_INFORMATION = {
  name: "",
  type: "",
  primaryCurrency: "",
  barcode: "",
  locationId: "",
  status: "",
  longitude: "0",
  latitude: "0",
  loadingBayArea: "",
  loadingBayCapacity: "0",
  country: "",
  state: "",
  emirate: "",
  city: "",
  postalCode: "",
  address: "",
  firstServiceDate: new Date(),
  inactiveDate: new Date(),
  serviceDays: [],
};
export const OPERATION_WINDOW_DEFAULT = {
  startDateTime: new Date(),
  endDateTime: new Date(),
  cutOffTime: new Date(),
};
export const OFFICES_DEFAULT = {
  ...OPERATION_WINDOW_DEFAULT,
  officeId: "",
  officeName: "",
  officeType: "",
  country: "",
  state: "",
  emirate: "",
  city: "",
  postalCode: "",
  address: "",
  barcode: "",
  startDate: new Date(),
  inactiveDate: new Date(),
  status: "",
  longitude: "0",
  latitude: "0",
  operationalWindows: [],
};
export const internalSLADefault = {
  region: "",
  serviceType: "",
  activityType: "",
  responseTime: "0",
  attendedTime: "0",
  resolutionTime: "0",
};
export const INSURANCE_LIMIT_DEFAULT = {
  customerId: "",
  currency: "",
  area: "",
  limit: "0",
};
export const CASH_CENTER_DEFAULT = {
  ...CASH_CENTER_INFORMATION,
  operationalWindows: [],
  offices: [],
  insuranceLimits: [],
  contactPersons: [],
  escalationGroups: [],
  internalSLAs: [],
};
